// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { appSelect } from './app-utils';

/** Represents an empty value. */
export const EMPTY_VALUE = Symbol('@@empty_value');

/** Represents an empty reference. */
export const EMPTY_REF = Symbol('@@empty_ref');

/** Decimal separator characters allowed in NumericFormat inputs. */
export const DECIMAL_SEPARATORS: string[] = ['.', ','];

/** Idle timeout in ms before showing the inactivity modal and logging out. */
export const IDLE_TIMEOUT_MS = appSelect({
  advisor: 30 * 60 * 1000,
  client: 10 * 60 * 1000,
  test: 10 * 60 * 1000,
});
